import { ThemeProvider } from '@mui/material';
import axios from 'axios';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from "react-router-dom";
import App from './App';
import './index.css';
import { store } from './redux/store';
import reportWebVitals from './reportWebVitals';
import theme from './theme';
import { ErrorBoundary } from './ErrorBoundary';
import { getOrCreateDeviceId, getOrCreateBrowserSessionId } from './utils/common';

// Send device/session identity on every axios request (raw axios + instances),
// so API logging and session device-binding stay consistent across all calls.
//
// This MUST be an interceptor, not `axios.defaults.headers.common`. Defaults are
// evaluated once at boot, so a logout that clears localStorage mid-session left
// the default holding a stale device id while axiosInstance/RTK Query re-read the
// new one per request. The login token then got bound to the stale id and the
// first dashboard call was rejected with "This session is bound to another
// device". Reading per request keeps every client in sync.
axios.interceptors.request.use((config) => {
  config.headers['x-device-id'] = getOrCreateDeviceId();
  config.headers['x-session-id'] = getOrCreateBrowserSessionId();
  return config;
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ErrorBoundary>
  <BrowserRouter>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </Provider>
  </BrowserRouter>
   </ErrorBoundary>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log);
reportWebVitals();
